/* @ngInject */
const labels = (
  accountLabels,
  settingLabels,
  wagonLabels,
  areaLabels,
  railwayLabels,
  contactLabels,
  dispatchLabels,
  ownerLabels,
  trainLabels,
  emailLabels,
  phoneLabels,
  movementLabels,
  saleLabels,
  axletreeLabels,
  pieceLabels,
  sterileLabels,
  commandeLabels
) => {
  const self = {}

  self.wagon = wagonLabels
  self.area = areaLabels
  self.railway = railwayLabels
  self.contact = contactLabels
  self.email = emailLabels
  self.phone = phoneLabels
  self.owner = ownerLabels
  self.dispatch = dispatchLabels
  self.train = trainLabels
  self.account = accountLabels

  self.movement = movementLabels

  self.sale = saleLabels
  self.axletree = axletreeLabels
  self.piece = pieceLabels
  self.sterile = sterileLabels

  self.setting = settingLabels
  self.commande = commandeLabels

  self.return = 'Retour'
  self.back = 'Retour'
  self.cancel = 'Annuler'
  self.removeLast = 'Supprimer les dernières'
  self.search = 'Rechercher'
  self.localsearch = 'Rechercher dans la page'
  self.validate = 'Valider'
  self.newSearch = 'Nouvelle recherche'
  self.modify = 'Modifier'
  self.edit = 'Modifier'
  self.select = 'Sélectionner'
  self.selected = 'Sélectionné'
  self.order = 'Ordre'
  self.add = 'Ajouter'
  self.create = 'Créer'
  self.previous = 'Précédent'
  self.clear = 'Effacer'
  self.next = 'Suivant'
  self.continue = 'Continuer'

  self.display = 'Afficher'
  self.show = 'Afficher'
  self.hide = 'Masquer'
  self.sort = 'Trier'
  self.excel = 'Excel'
  self.download = 'Télécharger'
  self.save = 'Sauvegarder'
  self.copy = 'Copier'
  self.title = 'Titre'

  self.showOwnerWagons = 'Voir les wagons du propriétaire'

  self.noElementsFound = 'Aucun élément'

  self.reinitInput = 'Ré-initialiser la saisie'

  self.begin = 'Commencer !'

  self.copied = 'Copié dans le presse papier'

  self.fileName = 'Nom du fichier'

  self.generateBLWagons = 'Générer le bon de livraison wagons'
  self.generateBLEssieux = 'Générer le bon de livraison essieux'

  self.yes = 'Oui'
  self.no = 'Non'

  self.stat = {
    title: 'Statistiques',
  }

  self.list = {
    title: 'Listes',
  }

  self.search = {
    title: 'Recherche',
  }

  self.export = {
    unparkCertificate: 'Certificat de dégarage',
    parkCertificate: 'Certificat de garage',
    readinessCertificate: 'Certificat de mise à disposition',
    axletreesCertificate: 'Relevé d\'essieux',
    personalisableExport: 'Personalisable',
    personalisableExportOld: 'Simple tableur',
    blank: 'Simple tableur',
    list: 'Liste',
    sort: 'Tri',
    scrapping: 'Ferraillage',
    dispositionSort: 'Tri pour MAD',
    compositionTrain: 'Composition de train',
    bulletinFreinage: 'Bulletin Freinage',
    blWagons: 'Bon de livraison wagons',
    blEssieux: 'Bon de livraison essieux',
  }

  self.selectAll = (_selected) => {
    return 'Tout ' + (_selected ? 'désélectionner' : 'sélectionner')
  }

  self.editField = (_fieldLabel) => {
    return 'Modification : ' + _fieldLabel
  }
  self.editFields = (_fieldLabel) => {
    return 'Modification de tous : ' + _fieldLabel
  }

  self.editDispositions = 'Modifications des mises à disposition des wagons'
  self.editDisposition = 'Modifications des mises à disposition du wagon'
  self.updateAllAxletrees = 'Modifications de tous les essieux'

  self.input = {
    invalid: 'Ce champ est invalide',
    required: 'Ce champ est obligatoire',
    maxlength: (_length) => {
      return 'Ce champ est trop long (max = ' + _length + ')'
    },
    minlength: (_length) => {
      return 'Ce champ est trop cours (min = ' + _length + ')'
    },
    number: 'Valeur incorrecte (format: 0-9)',
    email: 'Adresse incorrecte (format: abc@abc.com)',
  }

  self.ask = {
    excelExport: 'Êtes vous sûr de vouloir exporter ces données au format xls ?',
    reinitSearch: 'Êtes-vous sûr de vouloir réinitialiser cette recherche ?',
    deleteSortProperties: 'Êtes-vous sûr de vouloir réinitialiser le tri ?',
    warningSize: (size) => `Êtes-vous sûr de vouloir afficher ${size} wagons ?`,
  }

  self.choices = {
    area: 'Choix de la zone',
    railway: 'Choix de la voie',
    owner: 'Choix du propriétaire',
    position: 'Choix de la position : ',
    sort: 'Choix du tri : ',
  }

  self.menus = {
    create: 'Créer',
    use: 'Utiliser',
    consult: 'Consulter',
    scrap: 'Ferrailler',
    invoice: 'Facturer',
    account: 'Mon compte',
    option: 'Options',
    login: 'Connexion',
    logout: 'Déconnexion',
    maneuver: 'Manœuvrer',
    wagonId: 'Vérifier Numéro',
  }

  self.consult = {
    wagon: 'Consulter les wagons',
    train: 'Consulter les trains',
    railway: 'Consulter les voies',
    area: 'Consulter les zones',
    dispatch: 'Consulter les dépêches',
    owner: 'Consulter les propriétaires',
    search: 'Rechercher des wagons',
  }

  self.use = {
    move: 'Déplacer des wagons',
    unpark: 'Dégarer un train',
    work: 'Faire des travaux',
    autocontrole: 'Calcul Identifiant Wagon',
  }

  self.new = {
    train: 'De nouveaux trains',
    area: 'De nouvelles zones',
    railway: 'De nouvelles voies',
    owner: 'De nouveaux propriétaires',
    dispatch: 'Une nouvelle dépêche',
  }

  self.maneuver = {
    move: 'Déplacer',
    park: 'Garer',
    scrap: 'Ferrailler',
    unpark: 'Dégarer',
    announce: 'Annoncer',
  }

  self.categories = {
    table: 'Champs présents dans les tableaux',
    excel: 'Champs à exporter sur excel',
    details: 'Champs dans la vue en détail',
    select: 'Champs visibles lors de la sélection',
  }

  self.log = {
    failure: 'Connection avec le serveur impossible.',
  }

  self.error = {
    server: (_status) => {
      let message = 'Oups, une erreur est survenue avec le serveur\n'
      if (_status === 404) {
        message += 'Page introuvable'
      }
      return message
    },
    input: {
      format: (_format) => {
        return 'Le champ ne correspond pas au format' + (_format ? ' (' + _format + ')' : '')
      },
      minlength: (_minlength) => {
        return 'Le champ est trop cours' + (_minlength ? ' (min : ' + _minlength + ')' : '')
      },
      maxlength: (_maxlength) => {
        return 'Le champ est trop long' + (_maxlength ? ' (max : ' + _maxlength + ')' : '')
      },
      required: 'Le champ est requis',
      email: 'L\'email n\'est pas valide',
      number: 'Le nombre n\'est pas valide',
      exists: 'Cette valeur existe déjà',
    },
    date: {
      required: 'Cette date est requise',
      invalid: 'Cette date est invalide',
    },
    password: {
      required: 'Ce mot de passe est requis',
      length: (_min, _max) => {
        return 'Votre mot de passe doit faire entre ' + _min + ' et ' + _max + ' caractères'
      },
      pattern: 'Le mot de passe est invalide',
      confirmation: 'Les deux mots de passe ne correspondent pas',
    },
    username: {
      length: (_min, _max) => {
        return 'Votre nom d\'utilisateur doit faire entre ' + _min + ' et ' + _max + ' caractères.'
      },
      required: 'Le nom d\'utilisateur est requis',
      exists: 'Ce nom d\'utilisateur existe déjà',
    },
  }

  self.choose = (_isChoose) => {
    return _isChoose ? 'Modifier' : 'Choisir'
  }

  return self
}

export default labels



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/resources/labels.resource.js